<template>
  <div class="con-wrap">
    <loading :m="[99, 99, 99, 99, 99, 100]"></loading>
    <header-con></header-con>
    <div id="bmap"></div>
    <div class="des-wrap pos-box" v-show="desFlag">
      <img
        src="../../../assets/images/GIS/close.png"
        alt=""
        @click="desFlag = false"
        class="close-img"
      />
      <h2>
        {{
          companyInfo.divisionSiteId
            ? companyInfo.name
            : companyInfo.divisionName
        }}
      </h2>
      <!--      <p class="company-name">{{companyInfo.divisionName}}</p>-->
      <p class="msg-box">
        {{
          (companyInfo.divisionSiteId ? "项目地址：" : "公司地址：") +
            companyInfo.address
        }}
      </p>
      <!--      <p class="msg-box">公司简介：</p>-->
      <div class="des-con" id="desCon" ref="desCon">
        <div id="companyDes">
          <!-- <p class="company-des" :class='{"company-des0":showEllipsis}' :ref="'companyDes'+index" v-for="(item,index) in companyInfo.description" :id="'companyDes'+index" :key="index">{{item}}</p> -->
          <p class="company-des" v-html="companyInfo.description"></p>
        </div>
        <!-- <span v-if="showEllipsis">……</span> -->
      </div>
      <p
        class="more-btn"
        @click="goPage('companyInfo', companyInfo.id)"
        v-show="!companyInfo.divisionSiteId"
      >
        —— 点击查看更多 ——
      </p>
    </div>

    <!--  跳转按钮  -->
    <div class="btn-wrap">
      <el-button @click="goPage('integratedDisplay')" class="GIS-btn"
        >企业总览</el-button
      >
      <el-button @click="goPage('companyInfo')" class="GIS-btn"
        >企业简介</el-button
      >
      <el-button
        @click="goPage('video3d')"
        v-if="
          companyInfo.id == 7 || companyInfo.id == 6 || companyInfo.id == 72
        "
        class="GIS-btn"
        >企业三维</el-button
      >
      <el-button @click="goPage('videoMonitoring')" class="GIS-btn"
        >企业视频</el-button
      >
    </div>
  </div>
</template>

<script>
import headerCon from "../../../components/header";
import loading from "../../../components/loading.vue";
import { BMPGL } from "../../../assets/js/tools/BMapGL";
import zhuangbei3d from "@/views/safetyManagement/video/zhuangbei3d";

export default {
  name: "projectOverview",
  data() {
    return {
      divisionArr: [],
      desFlag: true,
      infoFlag: false,
      companyInfo: {},
      firstId: 6,
      videoData: [],
      showEllipsis: false,
      companyDesH: 0,
      nowCompanyId: "",
      videoPath: "",
      videoName: "",
      centerPoint: [106.270747, 38.0057401], //地图中心点
      mapZoom: 6,
      secView: false,
      nowImg: "",
      labelArr: [],
      numberOfRows: 0,
      bottomNumber: 0,
      line_height: "",
      projectList: [],
      projectLabelArr: [],
      companyLength: [],
      nearPointObj1: {},
      leftRight: [],
      normalPointArr1: [],
    };
  },
  components: {
    headerCon,
    loading,
  },
  mounted() {
    this.companyDesH = document.getElementById("companyDes").style.height;
    // this.getData();
    this.getcompanyLength();
    // this.rowsNumber();
    // this.getProject();
  },
  methods: {
    //页面跳转
    goPage(path) {
      if (this.companyInfo.level == 1 || this.companyInfo.level == 2) {
        if (path == "video3d") {
          // if( this.companyInfo.id != 7 ){
          //   return false;
          // }
          if (this.companyInfo.id == 6) {
            path = "zhuangbei3d";
          } else if (this.companyInfo.id == 72) {
            path = "nanjing3d";
          }
        }
        this.$router.push({
          path: `/` + path,
          query: { id: this.companyInfo.id },
        });
        this.$cookie.set("companyInfoId", this.companyInfo.id);
      }
    },
    getProject(id) {
      let nowId = id ? id : 0;
      this.$get("gisoverview/getdivisionsitelist", [nowId]).then(
        (res) => {
          this.projectList = [];
          for (let i in res) {
            res[i].point = [];
            if (res[i].coordinate) {
              res[i].point.push(res[i].coordinate.split(",")[0] * 1);
              res[i].point.push(res[i].coordinate.split(",")[1] * 1);
            }
            this.projectList.push(res[i]);
          }
          this.initMap();
          if (this.$cookie.get("companyInfoId") != "") {
            this.getCompanyInfo(this.$cookie.get("companyInfoId"));
          }
        },
        (err) => {
          console.log(err);
          this.initMap();
        }
      );
    },
    //获取公司列表长度
    getcompanyLength() {
      // let nowId = id ? id : 0;
      this.$get("gisoverview/getdivisionlist", [0])
        .then((res) => {
          this.companyLength = res.length;
        })
        .then(() => {
          if (this.companyLength == 1) {
            this.getData(this.$cookie.get("firstDivisionId"));
          } else {
            this.getData(0);
          }
        });
    },
    //公司列表
    getData(id) {
      let nowId = id ? id : 0;
      this.$get("gisoverview/getdivisionlist", [nowId])
        .then(
          (res) => {
            this.divisionArr = [];
            for (let i in res) {
              res[i].point = [];
              if (res[i].coordinate) {
                res[i].point.push(res[i].coordinate.split(",")[0] * 1);
                res[i].point.push(res[i].coordinate.split(",")[1] * 1);
              }
              this.divisionArr.push(res[i]);
            }
            // 地图点位分组（直线距离小于0.72分成一组，所有重合组放入nearPointObj；无重合点放入normalPointArr）
            // console.log(this.divisionArr)
            let nearPointObj = {};
            let normalPointArr = [];
            let nearPointObj0 = [];
            // let nearPointArr0=[]
            let hasCompare = [];
            for (let i = 0; i < this.divisionArr.length; i++) {
              let nearPointArr = [];
              let nearPointArr0 = [];
              // 避免重合点位分组，包含重复数据
              if (hasCompare.indexOf(i) === -1) {
                for (let j = i + 1; j < this.divisionArr.length; j++) {
                  let a = Math.abs(
                    this.divisionArr[i].point[0] - this.divisionArr[j].point[0]
                  );
                  let b = Math.abs(
                    this.divisionArr[i].point[1] - this.divisionArr[j].point[1]
                  );
                  let distance = Math.sqrt(a * a + b * b);
                  //  console.log(this.divisionArr[i].divisionName,this.divisionArr[j].divisionName,a,b,distance)
                  if (distance <= 0.62) {
                    hasCompare.push(j);
                    nearPointArr.push(this.divisionArr[j]);
                  } else {
                    if (b < 0.3 && a < 4) {
                      // hasCompare.push(j)
                      // nearPointArr0.push(this.divisionArr[j])
                      let c =
                        this.divisionArr[i].point[0] -
                        this.divisionArr[j].point[0];
                      let arr1 = [
                        this.divisionArr[i].divisionName,
                        this.divisionArr[j].divisionName,
                      ];
                      let arr = [this.divisionArr[j], this.divisionArr[i]];
                      if (c < 0) {
                        this.leftRight.push(this.divisionArr[i].id);
                      } else {
                        this.leftRight.push(this.divisionArr[j].id);
                      }
                      // this.leftRight[this.divisionArr[j].id] = arr
                      // console.log(arr1,c,this.leftRight)
                    }
                  }
                }
                //  if(nearPointArr0.length>0){
                //   nearPointArr0.push(this.divisionArr[i])
                //   nearPointObj0[this.divisionArr[i].id] = nearPointArr
                //  }
                if (nearPointArr.length > 0) {
                  nearPointArr.push(this.divisionArr[i]);
                  nearPointObj[this.divisionArr[i].id] = nearPointArr;
                } else {
                  normalPointArr.push(this.divisionArr[i]);
                }
              }
            }
            // console.log(nearPointObj0,)
            this.nearPointObj1 = nearPointObj;
            this.normalPointArr1 = normalPointArr;

            this.firstId = this.divisionArr[0].id;
            this.desFlag = true;
            if (this.companyLength == 1) {
              if (this.$route.query.id) {
                this.getCompanyInfo(this.$route.query.id);
              } else {
                this.getCompanyInfo(this.firstId);
              }
              this.centerPoint = this.divisionArr[0].point;
              this.mapZoom = 6;
            } else {
              if (nowId == 0) {
                if (this.$route.query.id) {
                  this.getCompanyInfo(this.$route.query.id);
                } else {
                  this.getCompanyInfo(this.firstId);
                }
                this.mapZoom = 6;
                this.centerPoint = [106.270747, 33.0057401];
              } else {
                this.centerPoint = this.divisionArr[0].point;
                this.mapZoom = 10;
              }
            }

            // this.initMap();
            // if(this.$cookie.get('companyInfoId') != ''){
            //   this.getCompanyInfo(this.$cookie.get('companyInfoId'));
            // }
          }
          // (err) => {
          //   console.log(err);
          //   this.initMap();
          // }
        )
        .then(() => {
          this.getProject(id);
        });
    },

    initMap() {
      let _this = this;
      BMPGL()
        .then((BMapGL) => {
          let map = new BMapGL.Map("bmap", { minZoom: 6 });
          // map.setMapStyleV2({styleJson:eval("option")});
          // let test = map.addControl(new BMapGL.MapTypeControl() );//控件，默认左上角
          // 创建点坐标 axios => res 获取的初始化定位坐标
          let point = new BMapGL.Point(
            _this.centerPoint[0],
            _this.centerPoint[1]
          );
          // 初始化地图，设置中心点坐标和地图级别
          map.centerAndZoom(point, _this.mapZoom);
          //开启鼠标滚轮缩放
          map.enableScrollWheelZoom(true);
          map.setTilt(10); //倾斜程度
          // for(let i in _this.divisionArr){
          //   let now = _this.divisionArr[i];
          //   _this.makePonit(map ,now)
          // }
          // console.log(_this.normalPointArr1,_this.nearPointObj1)
          for (let i in _this.normalPointArr1) {
            let now = _this.normalPointArr1[i];
            _this.makePonit(map, now);
          }
          for (let i in _this.nearPointObj1) {
            _this.makeNearPonit(map, _this.nearPointObj1[i]);
          }
          for (let i in _this.projectList) {
            let nowProject = _this.projectList[i];
            _this.makeProject(map, nowProject);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //地图标记点
    makeProject(map, obj) {
      let _this = this;
      let icon;
      icon = new BMapGL.Icon(
        require("../../../assets/images/GIS/project.png"),
        new BMapGL.Size(30, 30)
      );
      let mkr = new BMapGL.Marker(
        new BMapGL.Point(obj.point[0], obj.point[1]),
        { icon: icon }
      );
      let labelOffest = [15, -10];
      let label = new BMapGL.Label("", {
        offset: new BMapGL.Size(labelOffest[0], labelOffest[1]),
      });
      let labelStyle = {
        color: "#24CF30",
        fontSize: "16px",
        fontWeight: "600",
        height: "20px",
        lineHeight: "20px",
        fontFamily: "黑体",
        border: "none",
        background: "transparent",
        position: "absolute",
        top: "10px",
        left: "20px",
        cursor: "pointer",
      };
      label.setStyle(labelStyle);
      mkr.setLabel(label);
      map.addOverlay(mkr);
      this.projectLabelArr.push(label);
      label.addEventListener("mouseover", function(e) {
        _this.projectLabelArr.forEach((item) => {
          if (item.content !== e.currentTarget.content) {
            item.setStyle({ color: "#24CF30", fontSize: "16px" });
          } else {
            item.setStyle({ color: "#00B70D", fontSize: "18px" });
            _this.getProjectInfo(obj.divisionSiteId);
          }
        });
        _this.labelArr.forEach((item) => {
          if (item.content !== e.currentTarget.content) {
            item.setStyle({ color: "#366ac2", fontSize: "18px" });
          } else {
            item.setStyle({ color: "#1949FF", fontSize: "20px" });
            _this.getProjectInfo(obj.divisionSiteId);
          }
        });
        // label.setStyle({ color: "#f7d800", 'fontSize': '18px' });
        // _this.getCompanyInfo(obj.id);
      });
      mkr.addEventListener("mouseover", function(e) {
        _this.projectLabelArr.forEach((item) => {
          if (item.content !== e.target.getLabel().content) {
            item.setStyle({ color: "#24CF30", fontSize: "16px" });
          } else {
            item.setStyle({ color: "#00B70D", fontSize: "18px" });
            _this.getProjectInfo(obj.divisionSiteId);
          }
        });
        _this.labelArr.forEach((item) => {
          if (item.content !== e.currentTarget.content) {
            item.setStyle({ color: "#366ac2", fontSize: "18px" });
          } else {
            item.setStyle({ color: "#1949FF", fontSize: "20px" });
            _this.getProjectInfo(obj.divisionSiteId);
          }
        });
        // label.setStyle({ color: "#f7d800", 'fontSize': '18px' });
        // _this.getCompanyInfo(obj.id);
      });
    },

    makeNearPonit(map, arr) {
      let num = 0;
      arr.forEach((item, index) => {
        if (index !== 0) {
          num = index % 2 === 0 ? Math.abs(num) : -(Math.abs(num) + 25);
        }
        // console.log(num)
        let _this = this;
        let icon;
        let obj = item;
        //装备icon为红旗
        if (obj.id == 6) {
          icon = new BMapGL.Icon(
            require("../../../assets/images/GIS/flag.png"),
            new BMapGL.Size(30, 30)
          );
        } else {
          if (obj.level == 1) {
            icon = new BMapGL.Icon(
              require("../../../assets/images/GIS/l1.png"),
              new BMapGL.Size(30, 30)
            );
          } else if (obj.level == 2) {
            icon = new BMapGL.Icon(
              require("../../../assets/images/GIS/l2.png"),
              new BMapGL.Size(30, 30)
            );
          } else if (obj.level == 3) {
            icon = new BMapGL.Icon(
              require("../../../assets/images/GIS/l3.png"),
              new BMapGL.Size(30, 30)
            );
          }
        }

        let mkr = new BMapGL.Marker(
          new BMapGL.Point(obj.point[0], obj.point[1]),
          { icon: icon }
        );
        if (obj.id == this.$cookie.get("firstDivisionId")) {
          mkr.setTop(true);
        }
        let labelOffest = [15, -10 + num];
        let label = new BMapGL.Label(obj.divisionName, {
          offset: new BMapGL.Size(labelOffest[0], labelOffest[1]),
        });
        let labelStyle = {
          color: "#366ac2",
          fontSize: "18px",
          fontWeight: "600",
          height: "20px",
          lineHeight: "20px",
          fontFamily: "黑体",
          border: "none",
          background: "transparent",
          position: "absolute",
          top: "10px",
          left: "20px",
          cursor: "pointer",
        };
        let labelStylefirst = {
          color: "#1949FF",
          fontSize: "20px",
          fontWeight: "600",
          height: "20px",
          lineHeight: "20px",
          fontFamily: "黑体",
          border: "none",
          background: "transparent",
          position: "absolute",
          top: "10px",
          left: "20px",
          cursor: "pointer",
        };
        if (obj.id == this.$cookie.get("firstDivisionId")) {
          label.setStyle(labelStylefirst);
        } else {
          label.setStyle(labelStyle);
        }

        mkr.setLabel(label);
        map.addOverlay(mkr);
        this.labelArr.push(label);
        label.addEventListener("mouseover", function(e) {
          _this.labelArr.forEach((item) => {
            if (item.content !== e.currentTarget.content) {
              item.setStyle({ color: "#366ac2", fontSize: "18px" });
            } else {
              item.setStyle({ color: "#1949FF", fontSize: "20px" });
              _this.getCompanyInfo(obj.id);
            }
          });
          _this.projectLabelArr.forEach((item) => {
            if (item.content !== e.currentTarget.content) {
              item.setStyle({ color: "#24CF30", fontSize: "16px" });
            } else {
              item.setStyle({ color: "#00B70D", fontSize: "18px" });
              _this.getProjectInfo(obj.divisionSiteId);
            }
          });
        });
        label.addEventListener("click", function(e) {
          if (obj.id != 6 && obj.level != 3 && _this.companyLength != 1) {
            //定义marker上面弹出的信息窗口
            let title = !_this.secView
              ? "是否进入" + obj.divisionName + "主页？"
              : "是否返回GIS主页";
            let now_id = !_this.secView ? obj.id : 0;
            var opts = {
              width: 100, // 信息窗口宽度
              height: 30, // 信息窗口高度
              title, // 信息窗口标题
              enableMessage: true, //设置允许信息窗发送短息
            };
            window.check = function() {
              _this.secView = !_this.secView;
              _this.getData(now_id);
            };
            //定义信息窗口里面要显示的内容
            var content = "<div>";
            // content +=" <p>是否进入南京线材公司主页？</p>"
            content += "<button onclick='check()'>确定</button>";
            content += "</div>";
            var infoWindow = new BMapGL.InfoWindow(content, opts); // 创建信息窗口对象
            map.openInfoWindow(
              infoWindow,
              new BMapGL.Point(obj.point[0], obj.point[1])
            ); //开启信息窗口
          }
        });
        mkr.addEventListener("mouseover", function(e) {
          _this.labelArr.forEach((item) => {
            if (item.content !== e.target.getLabel().content) {
              item.setStyle({ color: "#366ac2", fontSize: "18px" });
            } else {
              item.setStyle({ color: "#1949FF", fontSize: "20px" });
              _this.getCompanyInfo(obj.id);
            }
          });
          _this.projectLabelArr.forEach((item) => {
            if (item.content !== e.currentTarget.content) {
              item.setStyle({ color: "#24CF30", fontSize: "16px" });
            } else {
              item.setStyle({ color: "#00B70D", fontSize: "18px" });
              _this.getProjectInfo(obj.divisionSiteId);
            }
          });
        });

        mkr.addEventListener("click", function(e) {
          if (obj.id != 6 && obj.level != 3) {
            //定义marker上面弹出的信息窗口
            let title = !_this.secView
              ? "是否进入" + obj.divisionName + "主页？"
              : "是否返回GIS主页";
            let now_id = !_this.secView ? obj.id : 0;
            var opts = {
              width: 100, // 信息窗口宽度
              height: 30, // 信息窗口高度
              title, // 信息窗口标题
              enableMessage: true, //设置允许信息窗发送短息
            };
            window.check = function() {
              _this.secView = !_this.secView;
              _this.getData(now_id);
            };
            //定义信息窗口里面要显示的内容
            var content = "<div>";
            // content +=" <p>是否进入南京线材公司主页？</p>"
            content += "<button onclick='check()'>确定</button>";
            content += "</div>";
            var infoWindow = new BMapGL.InfoWindow(content, opts); // 创建信息窗口对象
            map.openInfoWindow(
              infoWindow,
              new BMapGL.Point(obj.point[0], obj.point[1])
            ); //开启信息窗口
          }
        });
      });
    },

    makePonit(map, obj) {
      let _this = this;
      let icon;
      //装备icon为红旗
      if (obj.id == 6) {
        icon = new BMapGL.Icon(
          require("../../../assets/images/GIS/flag.png"),
          new BMapGL.Size(30, 30)
        );
      } else {
        if (obj.level == 1) {
          icon = new BMapGL.Icon(
            require("../../../assets/images/GIS/l1.png"),
            new BMapGL.Size(30, 30)
          );
        } else if (obj.level == 2) {
          icon = new BMapGL.Icon(
            require("../../../assets/images/GIS/l2.png"),
            new BMapGL.Size(30, 30)
          );
        } else if (obj.level == 3) {
          icon = new BMapGL.Icon(
            require("../../../assets/images/GIS/l3.png"),
            new BMapGL.Size(30, 30)
          );
        }
      }

      let mkr = new BMapGL.Marker(
        new BMapGL.Point(obj.point[0], obj.point[1]),
        { icon: icon }
      );
      if (obj.id == this.$cookie.get("firstDivisionId")) {
        mkr.setTop(true);
      }
      // let mkr = new BMapGL.Marker(new BMapGL.Point(obj.point[0], obj.point[1]));

      // console.log(this.leftRight.indexOf(obj.id),obj.divisionName)
      let labelOffest;
      if (this.leftRight.indexOf(obj.id) != -1) {
        labelOffest = [-125, -15];
      } else {
        labelOffest = [15, -10];
      }
      if (obj.id == 148) {
        labelOffest = [15, -5];
      }

      // if(obj.id == 7 || obj.id == 64|| obj.id== 60){
      //   labelOffest = [0, 10];
      // }else if(obj.id == 55 || obj.id== 62 || obj.id == 8){
      //   labelOffest = [0, -30];
      // } else if(obj.id == 77 || obj.id== 71){
      //   labelOffest = [0, 4];
      // } else if(obj.id == 70){
      //   labelOffest = [0, -10];
      // } else if(obj.id == 72 || obj.id == 76){
      //   labelOffest = [0, -30];
      // } else if(obj.id == 142){
      //   labelOffest = [0, 8];
      // } else if(obj.id == 144){
      //   labelOffest = [0, -20];
      // } else if(obj.id == 143){
      //   labelOffest = [0, 6];
      // } else if(obj.id == 114){
      //   labelOffest = [12, -17];
      // }
      let label = new BMapGL.Label(obj.divisionName, {
        offset: new BMapGL.Size(labelOffest[0], labelOffest[1]),
      });
      let labelStyle = {
        color: "#366ac2",
        fontSize: "18px",
        fontWeight: "600",
        height: "20px",
        lineHeight: "20px",
        fontFamily: "黑体",
        border: "none",
        background: "transparent",
        position: "absolute",
        top: "10px",
        left: "20px",
        cursor: "pointer",
      };
      let labelStylefirst = {
        color: "#1949FF",
        fontSize: "20px",
        fontWeight: "600",
        height: "20px",
        lineHeight: "20px",
        fontFamily: "黑体",
        border: "none",
        background: "transparent",
        position: "absolute",
        top: "10px",
        left: "20px",
        cursor: "pointer",
      };
      if (obj.id == this.$cookie.get("firstDivisionId")) {
        label.setStyle(labelStylefirst);
      } else {
        label.setStyle(labelStyle);
      }

      mkr.setLabel(label);
      map.addOverlay(mkr);
      this.labelArr.push(label);
      label.addEventListener("mouseover", function(e) {
        _this.labelArr.forEach((item) => {
          if (item.content !== e.currentTarget.content) {
            item.setStyle({ color: "#366ac2", fontSize: "18px" });
          } else {
            item.setStyle({ color: "#1949FF", fontSize: "20px" });
            _this.getCompanyInfo(obj.id);
          }
        });
        _this.projectLabelArr.forEach((item) => {
          if (item.content !== e.currentTarget.content) {
            item.setStyle({ color: "#24CF30", fontSize: "16px" });
          } else {
            item.setStyle({ color: "#00B70D", fontSize: "18px" });
            _this.getProjectInfo(obj.divisionSiteId);
          }
        });
        // label.setStyle({ color: "#f7d800", 'fontSize': '18px' });
        // _this.getCompanyInfo(obj.id);
      });
      // label.addEventListener("mouseout", function(e) {
      //   if(e.currentTarget.content === _this.companyInfo.divisionName) {
      //     label.setStyle({ color: "#f7d800", 'fontSize': '16px' });
      //   } else {
      //     label.setStyle({ color: "#fff", 'fontSize': '16px' });
      //   }
      // });
      label.addEventListener("click", function(e) {
        if (obj.id != 6 && obj.level != 3 && _this.companyLength != 1) {
          //定义marker上面弹出的信息窗口
          let title = !_this.secView
            ? "是否进入" + obj.divisionName + "主页？"
            : "是否返回GIS主页";
          let now_id = !_this.secView ? obj.id : 0;
          var opts = {
            width: 100, // 信息窗口宽度
            height: 30, // 信息窗口高度
            title, // 信息窗口标题
            enableMessage: true, //设置允许信息窗发送短息
          };
          window.check = function() {
            _this.secView = !_this.secView;
            _this.getData(now_id);
          };
          //定义信息窗口里面要显示的内容
          var content = "<div>";
          // content +=" <p>是否进入南京线材公司主页？</p>"
          content += "<button onclick='check()'>确定</button>";
          content += "</div>";
          var infoWindow = new BMapGL.InfoWindow(content, opts); // 创建信息窗口对象
          map.openInfoWindow(
            infoWindow,
            new BMapGL.Point(obj.point[0], obj.point[1])
          ); //开启信息窗口
        }
      });
      mkr.addEventListener("mouseover", function(e) {
        _this.labelArr.forEach((item) => {
          if (item.content !== e.target.getLabel().content) {
            item.setStyle({ color: "#366ac2", fontSize: "18px" });
          } else {
            item.setStyle({ color: "#1949FF", fontSize: "20px" });
            _this.getCompanyInfo(obj.id);
          }
        });
        _this.projectLabelArr.forEach((item) => {
          if (item.content !== e.currentTarget.content) {
            item.setStyle({ color: "#24CF30", fontSize: "16px" });
          } else {
            item.setStyle({ color: "#00B70D", fontSize: "18px" });
            _this.getProjectInfo(obj.divisionSiteId);
          }
        });
        // label.setStyle({ color: "#f7d800", 'fontSize': '18px' });
        // _this.getCompanyInfo(obj.id);
      });
      // mkr.addEventListener("mouseout", function(e) {
      //   // var label = this.getLabel();
      //   label.setStyle({ color: "#ffffff", 'fontSize': '16px' });
      // });

      mkr.addEventListener("click", function(e) {
        // let now_id = obj.id;
        // if(now_id != 6 && obj.level != 3){
        //   if( !_this.secView ){
        //     title = `是否进入 ${obj.divisionName} 主页`;
        //   }else{
        //     now_id = 0;
        //     title = `是否返回GIS主页`;
        //   }
        //   _this.$confirm(title, '', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: ''
        //   }).then(() => {
        //     _this.secView = !_this.secView;
        //     _this.getData( now_id );
        //   }).catch(() => {
        //
        //   });
        // }
        if (obj.id != 6 && obj.level != 3) {
          //定义marker上面弹出的信息窗口
          let title = !_this.secView
            ? "是否进入" + obj.divisionName + "主页？"
            : "是否返回GIS主页";
          let now_id = !_this.secView ? obj.id : 0;
          var opts = {
            width: 100, // 信息窗口宽度
            height: 30, // 信息窗口高度
            title, // 信息窗口标题
            enableMessage: true, //设置允许信息窗发送短息
          };
          window.check = function() {
            _this.secView = !_this.secView;
            _this.getData(now_id);
          };
          //定义信息窗口里面要显示的内容
          var content = "<div>";
          // content +=" <p>是否进入南京线材公司主页？</p>"
          content += "<button onclick='check()'>确定</button>";
          content += "</div>";
          var infoWindow = new BMapGL.InfoWindow(content, opts); // 创建信息窗口对象
          map.openInfoWindow(
            infoWindow,
            new BMapGL.Point(obj.point[0], obj.point[1])
          ); //开启信息窗口
        }
      });
    },
    //公司简介
    getCompanyInfo(id) {
      let _this = this;
      for (let i in this.divisionArr) {
        let now = this.divisionArr[i];
        if (now.id == id) {
          _this.companyInfo = now;
          //文本溢出处理
          let companyDes = document.getElementById("companyDes");
          let btn_wrap = document.querySelector(".btn-wrap");
          btn_wrap.style.display = "block";
          _this.$nextTick(() => {
            let companyDesH = companyDes.getBoundingClientRect().height;
            let conH = companyDes.parentElement.getBoundingClientRect().height;
            _this.showEllipsis = companyDesH > conH ? true : false;
            // this.rowsNumber()
          });
          _this.desFlag = true;
        }
      }
    },
    getProjectInfo(divisionSiteId) {
      let _this = this;
      for (let i in _this.projectList) {
        let now = _this.projectList[i];
        if (now.divisionSiteId == divisionSiteId) {
          _this.companyInfo = now;
          //文本溢出处理
          let companyDes = document.getElementById("companyDes");
          let btn_wrap = document.querySelector(".btn-wrap");
          btn_wrap.style.display = "none";
          _this.$nextTick(() => {
            let companyDesH = companyDes.getBoundingClientRect().height;
            let conH = companyDes.parentElement.getBoundingClientRect().height;
            _this.showEllipsis = companyDesH > conH ? true : false;
            // this.rowsNumber()
          });
          _this.desFlag = true;
        }
      }
    },
    //计算行数,其中a代表第i段的高度,b代表该行的行数，向上取整(名字实在取不出来了)
    rowsNumber() {
      let companyDes = document.getElementById("companyDes");
      let deconH =
        parseFloat(
          window.getComputedStyle(document.getElementById("desCon")).height
        ) * 1;
      let eleLength = companyDes.children.length;
      let line_height = parseFloat(
        window.getComputedStyle(document.getElementById("desCon")).lineHeight
      );
      let maxNumberOfRows = parseInt(deconH / line_height) + 1; //初始行高
      for (let i = 0; i < eleLength; i++) {
        // document.getElementById('companyDes'+i).style.setProperty('-webkit-line-clamp',100);
        let a = parseFloat(
          window.getComputedStyle(document.getElementById("companyDes" + i))
            .height
        ); //第i断高度
        let b = Math.ceil(a / line_height); //第i段行数
        if (maxNumberOfRows - b < 0) {
          document
            .getElementById("companyDes" + i)
            .style.setProperty("-webkit-line-clamp", maxNumberOfRows);
          break;
        } else {
          maxNumberOfRows = maxNumberOfRows - b;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.con-wrap {
  position: relative;
  width: 100%;
  #bmap {
    width: 100%;
    height: calc(100vh - 80px);
  }
  .info-btn {
    position: absolute;
    top: 10%;
    right: 2%;
    z-index: 99999;
    background: #1264b9;
    &:hover {
      color: #fff;
    }
  }
  .pos-box {
    position: absolute;
    width: 370px;
    //background: rgba(0,0,0, 0.7);
    background: #fff;
    z-index: 99;
    color: #333;
    h2 {
      font-size: 22px;
      font-weight: 600;
      width: 100%;
      text-align: center;
      margin: 20px auto 10px;
    }
    .more-btn {
      width: 100%;
      text-align: center;
      cursor: pointer;
      color: #333;
      font-size: 19px;
      font-weight: 600;
      height: 40px;
      line-height: 40px;
    }
    &.des-wrap {
      top: 80px;
      left: 0;
      height: 90vh;
      padding: 0 15px 0 25px;
      //p{
      //  line-height: 40px;
      //  color: #eee;
      //}
      .msg-box {
        font-size: 18px;
        font-weight: 300;
        line-height: 40px;
        color: #333;
      }
      .company-name {
        font-size: 18px;
        color: #333;
        font-weight: 600;
      }
      .des-con {
        //height: 650px;
        height: 67vh;
        overflow: hidden;
        position: relative;
        font-size: 18px;
        line-height: 40px;
        .company-des {
          color: #333;
        }
        .company-des0 {
          color: #333;
        }
        p {
          display: -webkit-box;
          -webkit-line-clamp: 100;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        // .company-des0::after{
        //   content:'......';
        //   position: absolute;
        //   height: 40px;
        //   top:var(--bottom,40px);
        //   right: 5px;
        //   width: 2em;
        //   line-height: 18px;
        //   text-indent: 0em;
        //   background: #000;
        // }
      }
    }
    &.pic-wrap {
      top: 80px;
      right: 0;
      padding: 0 20px;
      height: 401px;
      p {
        font-size: 16px;
        line-height: 22px;
        height: 22px;
        margin-bottom: 10px;
        color: #eee;
      }
      .pic-con {
        img {
          width: 155px;
          height: 100px;
          margin-bottom: 20px;
          display: inline-block;
          &:first-child {
            margin-right: 20px;
          }
        }
      }
    }
    &.video-wrap {
      top: 481px;
      right: 0;
      /*height: 479px;*/
      padding: 0 20px;
      h2 {
        .iconfont {
          cursor: pointer;
          font-size: 20px;
          color: #bbb;
        }
      }
      .video-box {
        margin-bottom: 10px;
        &:nth-child(2n + 1) {
          margin-right: 4.5%;
        }
        video {
          width: 155px;
          height: 100px;
          /*margin-right: 20px;*/
        }
        .video-title {
          height: 20px;
          line-height: 20px;
          font-size: 15px;
          text-align: center;
          color: #eee;
          cursor: pointer;
        }
      }
      .no-data {
        height: 150px;
        line-height: 150px;
        text-align: center;
        font-size: 18px;
      }
    }
    &.three-wrap {
      position: absolute;
      top: 713px;
      right: 0;
      padding-bottom: 16px;
      .three-con {
        width: 330px;
        height: 172px;
        margin: 0 auto;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .close-img {
    position: absolute;
    top: 3px;
    right: 10px;
    width: 20px;
    height: 20px;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    z-index: 99999;
  }
  .camera-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    display: none;
    .video-details-warp {
      position: absolute;
      top: 16%;
      left: 27%;
      padding: 20px;
      z-index: 999999;
      background: #12162b;
      p {
        color: #fff;
        font-size: 16px;
        margin: 0;
      }
      #myPlayer {
        margin-top: 10px;
        width: 850px;
        height: 600px;
        z-index: 999999;
      }
      span {
        color: #fff;
        position: absolute;
        top: 16px;
        right: 25px;
        z-index: 999999;
        cursor: pointer;
      }
    }
  }
  /* 跳转按钮 */
  .btn-wrap {
    position: absolute;
    bottom: 15px;
    left: 0;
    /*width: 100%;*/
    text-align: center;
    z-index: 99;
    //background: rgba(0, 0, 0, 0.7);
    border-radius: 6px;
    background: #fff;
    padding: 12px 30px;
    margin-left: 40%;
    .el-button {
      margin-left: 30px;
      //border: 2px solid #198DFF;
    }
  }
}
</style>
